import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import mediaQuery from '@/lib/styling/mediaQuery';
import { type OmitFramerProps, type HTMLDivProps } from '@/lib/types';
import isTouchDevice from '@/lib/utils/isTouchDevice';

type LoginContentWrapperProps = OmitFramerProps<HTMLDivProps> & {
  visible: boolean;
};

const StyledContentWrapper = styled(motion.section)<LoginContentWrapperProps>(
  ({ visible }) => ({
    paddingRight: 36,
    height: visible ? 'auto' : 0,
    flex: 1,
    maxWidth: '50%',
    boxSizing: 'border-box',
    [mediaQuery(768)]: {
      paddingRight: 24,
    },
    [mediaQuery(450)]: {
      paddingRight: 16,
    },
  }),
);

const LoginContentWrapper = (props: LoginContentWrapperProps) => (
  <StyledContentWrapper
    initial={{
      opacity: 0,
    }}
    animate={{ opacity: 1 }}
    transition={{
      delay: isTouchDevice() ? 0.2 : 0,
    }}
    {...props}
  />
);

export default LoginContentWrapper;
